import React, { useEffect, useState } from 'react'
import { getLegalPage } from 'api/content'
import { scrollToHash } from 'lib/window/scrollUtils'
import { Location } from 'history'
import useDidChange from 'hooks/useDidChange'
import HeadData from 'components/Common/HeadData'
import MarkdownRender from 'LuxKit/MarkdownRender'
import ErrorPage from 'components/Pages/ErrorPage'
import LoadingIndicator from 'components/Common/Loading/LoadingIndicator'
import Heading from 'LuxKit/Typography/Heading'
import Subtitle from 'LuxKit/Typography/Subtitle'
import Accordion from 'LuxKit/Accordion'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import StaticContentPageContainer from 'components/Common/StaticContentPageContainer'

interface Props {
  slug : string;
  location? : Location<any>;
}

function FrequentFlyerPage(props: Props) {
  const { slug, location } = props
  const [flyerContent, setFlyerContent] = useState<{
    title: string
    content: Array<any>
  }>({
    title: '',
    content: [],
  })
  const [error, setError] = useState<any>(null)

  useEffect(() => {
    getLegalPage(slug)
      .then(page => {
        if (page) {
          return setFlyerContent({
            title: page.title,
            content: page.pageContent,
          })
        }
      })
      .catch(error => setError({ error }))
  }, [slug])

  const flyerContentChanged = useDidChange(flyerContent)
  useEffect(() => {
    if (flyerContentChanged && flyerContent && location) {
      scrollToHash(location.hash)
    }
  }, [flyerContent, flyerContentChanged, location])

  const { title, content } = flyerContent
  const loading = content.length === 0 && !error
  const errorStatus = error ? error.status : ''

  // using index var i to make sure the collapsible has the right order label
  let i = 1
  return (
    <>
      <HeadData title={title} />
      <StaticContentPageContainer>
        <Heading variant="heading3" as="h1">{title}</Heading>
        {loading && <LoadingIndicator/>}
        {errorStatus && <ErrorPage error={errorStatus} />}
        {!loading && content.map((term) => {
          if (term.contentTypeId === 'legalPageFaq') {
            return (
              <Accordion
                key={term.slug}
                heading={`${i++}. ${term.title}`}
                id={term.slug}
              >
                <MarkdownRender content={term.answer} />
              </Accordion>
            )
          } else {
            return (
              <VerticalSpacer gap={24} key={term.slug} id={term.slug}>
                <Subtitle variant="subtitle1" format="uppercase" as="h2">
                  {term.title}
                </Subtitle>
                <MarkdownRender content={term.description} />
              </VerticalSpacer>
            )
          }
        })}
      </StaticContentPageContainer>
    </>
  )
}

export default FrequentFlyerPage
